const html = document.getElementsByTagName('html')[0];
const head = document.getElementsByTagName('head')[0];

const hasTouch = 'ontouchstart' in window;
const ua = navigator.userAgent.toLowerCase();
const touch = hasTouch && !ua.match(/windows/);
const ipad = ua.indexOf('ipad') >= 0 || (ua.indexOf('macintosh') >= 0 && hasTouch);
const iphone = ua.match(/iphone/);
const ipod = ua.match(/ipod/);
const ios = (iphone || ipod || ipad);
const win = ua.match(/windows/);
const mac = ua.match(/macintosh/);
const android = ua.match(/android/);
const safari = ua.match(/safari/) && !ua.match(/chrome/);
const androidMobile = android && ua.match(/mobile/);
const androidTablet = android && !androidMobile;
const mobile = iphone || ipod || androidMobile;
const tablet = androidTablet || ipad;


//add classes
html.classList.add('device-' + (touch ? 'touch' : 'desktop'));
html.classList.add('html-' + (ipad ? 'ipad' : 'notipad'));
html.classList.add('font-weight-' + (mac ? 'thin' : 'normal'));
html.classList.add('mode-' + (mobile ? 'sp' : 'pc'));
if (safari) html.classList.add('browser-safari');


//viewport
(function () {
  if (!touch) return;
  const meta = document.querySelector('meta[name="viewport"]');
  const defaultValue = meta.getAttribute('content');

  function isLandscape() {
    let angle = screen && screen.orientation && screen.orientation.angle;
    if (angle === undefined) {
      angle = window.orientation as number;
    }
    if (angle != 0) {
      return true;
    }
    return false;
  }

  function initViewport() {
    if (!meta) return;
    let distW = 0;
    const outerW = Math[isLandscape() ? 'max' : 'min'](window.outerWidth, window.outerHeight);
    if (outerW < 1440) {
      if (outerW >= 768 && !mobile) {
        // distW = 1280;
        distW = 1440;
      } else if (outerW < 375) {
        // } else {
        // SPは375固定表示
        distW = 375;
      }
    }
    if (mobile && outerW > 759) {
      distW = 759;
    }
    let content = defaultValue;
    if (distW > 0) {
      const scale = outerW / distW;
      // content = `width=${distW}, initial-scale=${scale}, minimum-scale=${scale}, maximum-scale=${scale}`;
      content = `width=${distW}`;
    }
    meta.setAttribute('content', content);
  }

  window.addEventListener('orientationchange', initViewport);
  initViewport();
})();

  //100vh(for iOS)
  (function () {
    const _scrollTarget = (document.scrollingElement || document.documentElement);
    let _first = true;
    let _oldHeight = 0;
    let _validWidth = false;

    // const debug = true;
    const debug = false;

    let _dom;
    if (debug) {
      _dom = document.createElement('div');
      _dom.style.position = 'fixed';
      _dom.style.left = '50%';
      _dom.style.top = '50%';
      _dom.style.zIndex = '9999999';
      _dom.style.color = 'red';
      document.addEventListener('DOMContentLoaded', () => {
        document.body.appendChild(_dom);
      });
    }

    const setFillHeight = () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      //fbでw980,h111のような変な値が返る問題
      if (!_validWidth) {
        _validWidth = true;
        if (mobile && newWidth > 900) _validWidth = false;
        if (_validWidth) html.classList.add('html_validSize');
      }

      //一番上でのみinnerHeightを図る
      if (_first || _scrollTarget.scrollTop <= 0) {
        if (_oldHeight === newHeight) return;
        _oldHeight = newHeight;
        if (debug) {
          _dom.innerHTML = _dom.innerHTML + '<br>' + newWidth + ' / ' + newHeight + ' <- ' + _scrollTarget.scrollTop;
        }
        const vh = newHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }
      _first = false;
    };

    window.addEventListener('resize', setFillHeight);
    window.addEventListener('orientationchange', () => {
      _first = true;
      setFillHeight();
    });
    setInterval(setFillHeight, 33);
    setFillHeight();

    html.classList.add('html_domReady');
    setTimeout(function () {
      html.classList.add('html_domReady2');
    }, 300);
  })();

